import axios from 'axios';
import { baseUrl } from '../Pages/ApiCommonService';
import { expTokenProcessAndGenerate } from './AuthApis';

const token = sessionStorage.getItem('token');

export const getTemplateList = async () => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(`${baseUrl}api/master/templates`, {
            headers: {
                Authorization: `Bearer ${Token}`,
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error('Error fetching template list:', error);
        throw error;
    }
};

export const getBrokerTemplateConfig = async (brokerId: any) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(`${baseUrl}api/master/broker-template?brokerID=${brokerId}`, {
            headers: {
                Authorization: `Bearer ${Token}`,
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(`Error fetching broker template for BrokerID ${brokerId}:`, error);
        throw error;
    }
};

export const saveBrokerTemplateConfig = async (payload: {
    BrokerID: number;
    INT_TEMP_ID1: number;
    INT_TEMP_ID2: number;
    INT_TEMP_ID3: number;
    INT_TEMP_ID4: number;
    NUM_AMT: number;
}) => {

    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);


        const response = await axios.post(
            `${baseUrl}api/master/broker-template/save`,
            payload, // No request body
            {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    'Content-Type': 'application/json',
                },
            }
        );

        if (response.status === 200 || response.status === 201) {
            return response.data;
        }
    } catch (error) {
        console.error('Error saving broker template config:', error);
        throw error;
    }
};
